import AudiLogo from '../../assets/icons/audi/logo.svg';
import VWLogo from '../../assets/icons/vw/logo.svg';
import VWNLogo from '../../assets/icons/vwn/logo.svg';
import CupraLogo from '../../assets/icons/cupra/logo.svg';
import BentleyLogo from '../../assets/icons/bentley/logo.svg';
import LamborghiniLogo from '../../assets/icons/lamborghini/logo.svg';

export const brandLogos: Record<string, string> = {
  A: AudiLogo,
  V: VWLogo,
  S: CupraLogo,
  E: BentleyLogo,
  L: LamborghiniLogo,
  N: VWNLogo,
  C: VWLogo, // Skoda - using VW as fallback
  P: VWLogo, // Porsche - using VW as fallback
  M: VWLogo, // MAN - using VW as fallback
  '*': AudiLogo, // Default fallback
};
